module.exports = __webpack_public_path__ + "static/media/checkbox-focused.4b38e982.svg";